// @systeme: contrat
import { z } from 'zod';
import { SchemaInstant } from './elements.js';
export const SchemaFluxIcs = z.object({
    /** L'adresse secrète à coller dans Google Agenda, Apple Calendrier, Thunderbird ou Outlook. */
    url: z.string(),
    derniereLectureLe: SchemaInstant.nullable(),
    regenereLe: SchemaInstant.nullable(),
});
//# sourceMappingURL=ics.js.map